import { useDispatch, useSelector } from "react-redux";
import {statusChange} from "../redux/filters/actions";

function Filter(){
  const dispatch = useDispatch();
  const filter = useSelector(state=>state.filters);
  const handleStatusChange = (status) => {
    dispatch(statusChange(status));
  }; 
    return(
    <div className="flex items-center justify-between mb-12">
    <h4 className="mt-2 text-xl font-bold">Book List</h4>
    <div className="flex items-center space-x-4">
      <button onClick={()=>handleStatusChange("All")} className={`filter-btn ${filter.filter === 'All' && 'active-filter'}`} id="lws-filterAll">All</button>
      <button onClick={()=>handleStatusChange("feature")} className={`filter-btn ${filter.filter === 'feature' && 'active-filter'}`} id="lws-filterFeatured">Featured</button>
    </div>
  </div>
  );
}

export default Filter;
